<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Nanny’s Dimes</h1><ol class="toc" style="font-weight: bold;"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li><li id="toc-li-5"><a href="#/text/ch005#october-2016">9 October 2016</a></li><li id="toc-li-6"><a href="#/text/ch006#prologue">Prologue</a></li><li id="toc-li-7"><a href="#/text/ch007#nannys-dimes">Nanny’s Dimes</a></li><li id="toc-li-8"><a href="#/text/ch008#the-vanguard">The Vanguard</a></li><li id="toc-li-9"><span href="#/text/ch009#brians-story" title="Link target outside of Sample">Brian’s Story</span></li><li id="toc-li-10"><span href="#/text/ch010#zitas-story" title="Link target outside of Sample">Zita’s Story</span></li><li id="toc-li-11"><span href="#/text/ch011#gerrys-story" title="Link target outside of Sample">Gerry’s Story</span></li><li id="toc-li-12"><span href="#/text/ch012#howards-story" title="Link target outside of Sample">Howard’s Story</span></li><li id="toc-li-13"><span href="#/text/ch013#synopsis" title="Link target outside of Sample">Synopsis</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?710765d5